module.exports = __webpack_public_path__ + "img/asia_insurance_logo.e24c869f.png";